import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { getExhibitorEntryPassDetailsUrl, submitExhibitorEntryPassUrl, GET_ACCOUNT_ENTRY_PASS_DETAIL, getAccountEntryPassDetailUrl, GET_EXHIBITOR_ENTRY_PASS_DETAILS, SUBMIT_EXHIBITOR_ENTRY_PASS, headers, updateExhibitorEntryPassUrl, deleteEntryPassUrl, deleteEntryPassDriverDocUrl } from "../../../utils/constants";


export const getExhibitorEntryPassDetails_action = (ContractorID, UUID, exhibitionID) => async (dispatch) => {
    try {
        // Use AccountID for vendor users (RoleId == 7), otherwise use the provided ContractorID
        const finalContractorID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ?
            parseInt(sessionStorage.getItem("AccountIDSS")) : ContractorID;

        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ? null : sessionStorage.getItem("ExhRegistrationIDSS");
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhRegistrationID: finalExhRegistrationID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID") == null ? exhibitionID : sessionStorage.getItem("sessionExhibitionID"),
            ContractorID: finalContractorID,
            UUID: UUID
        }
        console.log("getExhibitorEntryPassDetails_action Action------->", params)

        const res = await axiosGet(getExhibitorEntryPassDetailsUrl, params, headers)

        dispatch({
            type: GET_EXHIBITOR_ENTRY_PASS_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const submitExhibitorEntryPass_action = (EntryDate, CategoryType, VendorID, CompanyName, PersonName, MobileNo, EmailID, ExhEntryPassList, id, mailData, StatusID, NoOfVehicle, vehicleList) => async (dispatch) => {
    try {
        const finalVendorID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ?
            sessionStorage.getItem("AccountIDSS") :
            (VendorID == 0 ? VendorID : VendorID != '' ? VendorID : null);
        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ?
            null :
            (id != '' && id != null ? id : sessionStorage.getItem("ExhRegistrationIDSS"));
        var tempListofVehicles = [...vehicleList]
        tempListofVehicles.length > 0 && tempListofVehicles.map((item, i) => {
            item.Id = finalExhRegistrationID != '' && finalExhRegistrationID != null ? `Exh-${finalExhRegistrationID}` : `Vendor-${finalVendorID}`
            item.srNo = i
        })
        const params = {
            UserID: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhRegistrationID: finalExhRegistrationID,
            EntryDate: EntryDate != '' ? EntryDate : null,
            CategoryType: CategoryType != '' ? CategoryType : null,
            VendorID: finalVendorID,
            CompanyName: CompanyName != '' ? CompanyName : null,
            PersonName: PersonName != '' ? PersonName : null,
            MobileNo: MobileNo != '' ? MobileNo : null,
            EmailID: EmailID != '' ? EmailID : null,
            ExhEntryPassList: ExhEntryPassList,
            mailData: mailData,
            StatusID: StatusID,
            NoOfVehicle: NoOfVehicle,
            vehicleList: tempListofVehicles,
        }

        const res = await axiosPost(submitExhibitorEntryPassUrl, params, headers)

        dispatch({
            type: SUBMIT_EXHIBITOR_ENTRY_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const updateExhibitorEntryPass_action = (EntryPassHdrID, editEntryHdrNo, ExhEntryPassList, VendorID, id, mailData, StatusID, NoOfVehicle, vehicleList) => async (dispatch) => {
    try {
        const finalVendorID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ?
            sessionStorage.getItem("AccountIDSS") :
            (VendorID == 0 ? VendorID : VendorID != '' ? VendorID : null);
        const finalExhRegistrationID = sessionStorage.getItem("RoleIDSS") == 7 || sessionStorage.getItem("RoleIDSS") == 17 ?
            null :
            (id != '' && id != null ? id : sessionStorage.getItem("ExhRegistrationIDSS"));
        var tempListofVehicles = [...vehicleList]
        tempListofVehicles.length > 0 && tempListofVehicles.map((item, i) => {
            item.Id = finalExhRegistrationID != '' && finalExhRegistrationID != null ? `Exh-${finalExhRegistrationID}` : `Vendor-${finalVendorID}`
            item.srNo = i
        })
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') == null ? null : JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            EntryPassHdrID: EntryPassHdrID,
            ExhEntryPassList: ExhEntryPassList,
            mailData: mailData,
            StatusID: StatusID,
            EntryNo: editEntryHdrNo,
            NoOfVehicle: NoOfVehicle,
            vehicleList: tempListofVehicles,
        }

        const res = await axiosPost(updateExhibitorEntryPassUrl, params, headers)

        dispatch({
            type: SUBMIT_EXHIBITOR_ENTRY_PASS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getAccountEntryPassDetail_action = (ExhEntryPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhEntryPassHdrID: ExhEntryPassHdrID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(getAccountEntryPassDetailUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_ENTRY_PASS_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteEntryPass_action = (ExhEntryPassHdrID) => async (dispatch) => {
    try {
        const params = {
            UserId: sessionStorage.getItem('loginDataSS') ? JSON.parse(sessionStorage.getItem('loginDataSS')).UserID : '',
            ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            ExhEntryPassHdrID: ExhEntryPassHdrID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(deleteEntryPassUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_ENTRY_PASS_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const deleteEntryPassDriverDoc_action = (EntryVehicleDtlID, ExitVehicleDtlID) => async (dispatch) => {
    try {
        const params = {
            // UserId: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            // ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
            EntryVehicleDtlID: EntryVehicleDtlID,
            ExitVehicleDtlID: ExitVehicleDtlID,
        }
        console.log("getPaymentList_action Action------->", params)

        const res = await axiosGet(deleteEntryPassDriverDocUrl, params, headers)

        dispatch({
            type: GET_ACCOUNT_ENTRY_PASS_DETAIL,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}